import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.svg";

export const frontmatter: BlogFrontmatter = {
  title: "Cyberhygien för småföretag",
  header: "Cyberhygien för småföretag",
  date: "2025-05-22",
  description:
    "Enkla vardagsrutiner som hjälper småföretag att minska cyberrisker och möta hårdare säkerhetskrav.",
  category: "säkerhet",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
};
